// extracted by mini-css-extract-plugin
module.exports = {"spacer":"Spacer_spacer__2UoF8","spacerText":"Spacer_spacerText__qtjzJ"};